import React from 'react';
import { FormHelperText, FormControl, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { useForm } from 'react-final-form';
import { FieldTitle, useInput, InputHelperText } from 'react-admin';
import { Editor as TinyEditor } from '@tinymce/tinymce-react';
import styles from './styles';
import axios from 'axios';
import getToken from '../../../utils/getToken';

const useStyles = makeStyles(styles, { name: 'RaRichTextInput' });

const getUploadUrl = async() => {
    const token = await getToken();
    return axios({
            url: process.env.REACT_APP_GRAPHQL_URI,
            method: 'post',
            data: {
                query: `mutation {
      uploadEvidenceImage {
        success
        image {
          url
          uploadUrl
        }
      }
    }`,
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            console.log(err.message);
        });
};

const uploadImage = async(file, uploadUrl) => {
    try {
        const response = await axios.put(uploadUrl, file, {
            headers: {
                'Content-Type': file.type,
            },
        });
        return response;
    } catch (err) {
        console.log(err);
    }
};

const sanitizeRestProps = ({
    alwaysOn,
    basePath,
    component,
    defaultValue,
    formClassName,
    initializeForm,
    input,
    isRequired,
    label,
    locale,
    meta,
    options,
    optionText,
    optionValue,
    record,
    resource,
    allowEmpty,
    source,
    textAlign,
    translate,
    translateChoice,
    toolbar,
    menubar,
    plugins,
    ...rest
}) => rest;

const TinyMCEEditor = (props) => {
    const {
        className,
        label,
        options = {},
        resource,
        source,
        type,
        config,
        helperText,
        plugins,
        toolbar,
        menubar,
        editorHeight = 700,
        editorWidth = '100%',
        init,
        fullWidth = true,
        margin = 'dense',
        templates,
        ...rest
    } = props;

    const {
        id,
        isRequired,
        input: { value },
        meta: { touched, error },
        input,
        meta,
    } = useInput(props);
    const classes = useStyles(props);

    const form = useForm();

    const backgroundImages = [

        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/diary.jpg', name: 'Diary (1 page - good quality) 5' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/diary-left-page.jpg', name: 'Diary Left Page' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/diary-right-page.jpg', name: 'Diary Right Page' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/diary-un-lined.jpg', name: 'Diary Un-lined' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/flower-love-letter-1.jpg', name: 'Flower love letter 1' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/flower-love-letter-2.jpg', name: 'Flower love letter 2' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/flower-love-letter-3.jpg', name: 'Flower love letter 3' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/flower-love-letter-4.jpg', name: 'Flower love letter 4' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/love-letter-6.jpg', name: 'Love Letter 6'},
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/newspaper-1.jpg', name: 'Newspaper 1'},
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/newspaper-2.png', name: 'Newspaper 2'},
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/newspaper-background-2.jpg', name: 'Newspaper Background 2'},
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/newspaper-background-grey.jpeg', name: 'Newspaper Background Grey'},
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/notepad-blank-top-ring-white.jpg', name: 'Notepad Blank Top Ring White'},
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/notepad-blank-torn-top.jpg', name: 'Notepad Blank Torn Top'},
        // { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/notepad-blank-torn.jpg', name: 'Notepad Blank Torn'},
        // { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/notepad-blank.jpg', name: 'Notepad Blank'},
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/old-note-2-edited.jpeg', name: 'Old note 2 Edited' },
        // { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/old-note-3-edited.jpeg', name: 'Old note 3 Edited' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/old-note-4-edited.jpeg', name: 'Old note 4 Edited' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/old-note-5-edited.jpeg', name: 'Old note 5 Edited' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/old-note-6-edited.jpeg', name: 'Old note 6 Edited' },
        // { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/organiser-blank-1.jpg', name: 'Organiser Blank 1' },
        // { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/organiser-blank-2.jpg', name: 'Organiser Blank 2' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/paper-torn.jpg', name: 'Paper Torn' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/pink-letter-1.jpg', name: 'Pink letter 1' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/white-notebook-2.jpg', name: 'White Notebook 2' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/white-notebook.jpg', name: 'White Notebook ' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/white-blank-crumpled.jpeg', name: 'White blank crumpled' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/birth-certificate-modern.jpg', name: 'Birth Certificate - Modern' },
        { link: 'https://murder57-evidence-background.s3.eu-west-2.amazonaws.com/new_backgrounds/bank-statement.jpg', name: 'Bank Statement' },
    ];
    // templates = backgroundImages;
    // const formats = 'https://fonts.googleapis.com/css2?family=Merriweather&https://fonts.googleapis.com/css2?family=Open+Sans&https://fonts.googleapis.com/css2?family=Ephesis&family=Bonheur+Royale&family=Birthstone&family=Dancing+Script&family=Architects+Daughter&family=Indie+Flower&family=Shadows+Into+Light&family=Birthstone+Bounce&family=Grechen+Fuemen&family=Allura&family=Nothing+You+Could+Do&family=Nanum+Pen+Script&family=Kristi&family=Nanum+Brush+Script&family=WindSong&family=Cedarville+Cursive&family=Dawning+of+a+New+Day&family=Fuggles&family=Give+You+Glory&family=Condiment';
    // const formats_copy = 'https://fonts.googleapis.com/css2?family=Merriweather&family=Open+Sans&family=Ephesis&family=Bonheur+Royale&family=Birthstone&family=Dancing+Script&family=Architects+Daughter&family=Indie+Flower&family=Shadows+Into+Light&family=Birthstone+Bounce&family=Grechen+Fuemen&family=Allura&family=Nothing+You+Could+Do&family=Nanum+Pen+Script&family=Kristi&family=Nanum+Brush+Script&family=WindSong&family=Cedarville+Cursive&family=Dawning+of+a+New+Day&family=Fuggles&family=Give+You+Glory&family=Condiment';
    const new_fonts = 'https://fonts.googleapis.com/css2?family=Open+Sans&family=Poppins&family=Montserrat&family=Source+Sans+Pro&family=Libre+Baskerville&family=Bitter&family=Lora&family=PT+Serif&family=Libre+Franklin&family=Red+Hat+Display&family=Flamenco&family=Alumni+Sans+Inline+One&family=Rubik+Dirt&family=Rubik+Wet+Paint&family=Creepster&family=Special+Elite&family=Nothing+You+Could+Do&family=Merienda&family=Kalam&family=The+Girl+Next+Door&family=Cedarville+Cursive&family=Reenie+Beanie&family=Covered+By+Your+Grace&family=La+Belle+Aurore&family=Homemade+Apple&family=Architects+Daughter&family=Permanent+Marker&family=Gloria+Hallelujah&family=Satisfy&family=Dancing+Script&family=Goblin+One&family=Bowlby+One+SC&family=Black+Ops+One';
    // const font_formats_copy = 'Merriweather=Merriweather, cursive;Open Sans=Open Sans, cursive;Ephesis=ephesis, cursive; Bonheur Royale=Bonheur Royale, cursive; Birthstone=Birthstone, cursive; Dancing Script=Dancing Script, cursive; Architects Daughter=Architects Daughter, cursive; Indie Flower=Indie Flower, cursive; Shadows Into Light=Shadows Into Light, cursive; Birthstone Bounce=Birthstone Bounce, cursive; Grechen Fuemen=Grechen Fuemen, cursive; Allura=Allura, cursive; Nothing You Could Do=Nothing You Could Do, cursive; Nanum Pen Script=Nanum Pen Script, cursive; Kristi=Kristi, cursive; Nanum Brush Script=Nanum Brush Script, cursive; WindSong=WindSong, cursive; Cedarville Cursive=Cedarville Cursive, cursive; Dawning of a New Day=Dawning of a New Day, cursive; Fuggles=Fuggles, cursive; Give You Glory=Give You Glory, cursive; Condiment=Condiment, cursive;';
    const new_font_format = 'Open Sans=Open Sans, cursive;Poppins=Poppins,cursive;Montserrat=Montserrat,cursive;Source Sans Pro=Source Sans Pro,cursive;Libre Baskerville=Libre Baskerville,cursive;Bitter=Bitter,cursive;Lora=Lora,cursive;PT Serif=PT Serif,cursive;Libre Franklin=Libre Franklin,cursive;Red Hat Display=Red Hat Display,cursive;Flamenco=Flamenco,cursive;Alumni Sans Inline One=Alumni Sans Inline One,cursive;Rubik Dirt=Rubik Dirt,cursive;Rubik Wet Paint=Rubik Wet Paint,cursive;Creepster=Creepster,cursive;Special Elite=Special Elite,cursive;Nothing You Could Do=Nothing You Could Do,cursive;Merienda=Merienda,cursive;Kalam=Kalam,cursive;The Girl Next Door=The Girl Next Door,cursive;Cedarville Cursive=Cedarville Cursive, cursive;Reenie Beanie=Reenie Beanie,cursive;Covered By Your Grace=Covered By Your Grace,cursive;La Belle Aurore=La Belle Aurore,cursive;Homemade Apple=Homemade Apple,cursive;Architects Daughter=Architects Daughter,cursive;Permanent Marker=Permanent Marker,cursive;Gloria Hallelujah=Gloria Hallelujah,cursive;Satisfy=Satisfy,cursive;Dancing Script=Dancing Script,cursive;Goblin One=Goblin One,cursive;Bowlby One SC=Bowlby One SC,cursive;Black Ops One=Black Ops One' ;
    const setupFunction = (editor) => {
        //Templates
        for (let i = 0; i < templates.length; i++) {
            editor.ui.registry.addMenuItem(templates[i].name, {
                text: templates[i].name,
                onAction: function() {
                    const content = editor.getContent();

                    var parser = new DOMParser();
                    var htmlDoc = parser.parseFromString(content, 'text/html');

                    var docStyle = htmlDoc.getElementById('document-style');

                    if (confirm('Changing the template will overrite any existing content, are you sure?')) {
                        editor.setContent(templates[i].template);
                    }

                },
            });
        }

        // Backgrounds
        for (let i = 0; i < backgroundImages.length; i++) {
            editor.ui.registry.addMenuItem(backgroundImages[i].name, {
                text: backgroundImages[i].name,
                onAction: function() {
                    var content = editor.getContent();

                    var parser = new DOMParser();
                    var htmlDoc = parser.parseFromString(content, 'text/html');

                    var docStyle = htmlDoc.getElementById('document-style');
                    var docBackground = htmlDoc.getElementById('evidence-background');
                    const backgroundImage = backgroundImages[i].link;

                    if (!docStyle) {
                        if (docBackground) {
                            docBackground.src = backgroundImage;
                            editor.setContent(htmlDoc.getElementsByTagName('body')[0].innerHTML);
                        } else {
                            editor.setContent(
                                `<img id="evidence-background"
                                    src="${backgroundImage}" 
                                    style="width: 210mm; 
                                    height: 297mm;
                                    object-fit: cover; 
                                    object-position: center; 
                                    position: absolute; 
                                    top: 0; 
                                    left: 0; z-index: -1;
                                ">` + 
                                `<div> ${content} </div>`
                            );
                        }
                    } else {
                        if (docStyle.tagName === 'DIV') {
                            docStyle.style = ''
                            docStyle.removeAttribute('id');
                            editor.setContent(
                                `<img id="evidence-background"
                                    src="${backgroundImage}" 
                                    style="width: 210mm; 
                                    height: 297mm; 
                                    object-fit: cover; 
                                    object-position: center; 
                                    position: absolute; 
                                    top: 0; 
                                    left: 0; z-index: -1;
                                ">` + 
                                `${docStyle.outerHTML}`
                            );
                        } else {

                        }
                    }
                },
            });
        }
    }

    if (typeof meta === 'undefined') {
        throw new Error(
            "The TinyMCEInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/react-admin/Inputs.html#writing-your-own-input-component for details."
        );
    }

    return ( 
        <FormControl error = {!!(touched && error) }
        fullWidth = { fullWidth }
        className = "ra-rich-text-input"
        margin = { margin }> {
            label !== '' && label !== false && ( 
                <InputLabel shrink htmlFor = { id }
                className = { classes.label }>
                <FieldTitle 
                    label = { label }
                    source = { source }
                    resource = { resource }
                    isRequired = { isRequired }
                    />
                </InputLabel >
            )
        } 
        <TinyEditor 
        margin = "normal"
        type = { type }
        error = {!!(touched && error) }
        helperText = { touched && error }
        className = { className }
        config = {
            { plugins, menubar, toolbar, ...options }
        }
        content = { value } {...options } {...input } {...sanitizeRestProps(rest) }
        apiKey = { process.env.REACT_APP_TINY_MCE_API_KEY }
        onEditorChange = {
            (content) => {
                form.change(source, content);
            }
        }
        init = {
            {
                height: editorHeight,
                width: editorWidth,
                allow_html_data_urls: true,
                menubar: 'file edit insert template background',
                selector: '#editor', // change this value according to your HTML
                forced_root_block: false,
                images_upload_handler: async function(blobInfo, success, failure) {
                    // Gets the preSignedUrl from the backend
                    const resp = await getUploadUrl();

                    // Data is null if there is any error
                    if (resp.data) {
                        // Graphql response object
                        const data = resp.data.uploadEvidenceImage;
                        // Uploads the file with the preSignedUpload url
                        const upload = await uploadImage(
                            blobInfo.blob(),
                            data.image.uploadUrl
                        );

                        if (upload.status === 200) {
                            // Insert the image URL into the editor
                            success(data.image.url);
                        }
                    } else {
                        failure(
                            `Image cannot be uploaded. Error: ${resp.errors[0].message}`
                        );
                        return;
                    }
                },
                content_css: [
                    '/TinyMCE.content.css',
                    new_fonts
                ],
                font_formats: new_font_format,
                menu: {
                    // add in our custom functions to a menu
                    template: {
                        title: 'Template',
                        items: templates.map(template => template.name)
                    },
                    background: {
                        title: 'Background',
                        items: backgroundImages.map(image => image.name)
                    }
                },
                plugins: [
                    'advlist autolink lists link image',
                    'charmap print anchor help',
                    'searchreplace visualblocks code',
                    'insertdatetime media table paste wordcount',
                    'autolink lists media table',
                    'textcolor colorpicker',
                ],
                toolbar: 'undo redo | formatselect | fontselect | fontsizeselect | forecolor | bold italic underline | \
                    alignleft aligncenter alignright | \
                    bullist numlist outdent indent | \
                    code table | help',
                setup: function(editor) {
                    setupFunction(editor);
                },
                verify_html: false
            }
        }
        />

        <FormHelperText
         error = {!!error }
         className = {!!error ? 'ra-rich-text-input-error' : '' } >
        <InputHelperText 
            error = { error }
            helperText = { helperText }
            touched = { touched }
        /> 
        </FormHelperText> </FormControl>
    );
};

TinyMCEEditor.propTypes = {
    className: PropTypes.string,
    input: PropTypes.object,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    editorWidth: PropTypes.string,
    meta: PropTypes.object,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    options: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    toolbar: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.array,
    ]),
    menubar: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    plugins: PropTypes.string,
};

TinyMCEEditor.defaultProps = {
    onBlur: () => {},
    onChange: () => {},
    onFocus: () => {},
    options: {},
    toolbar: true,
    menubar: true,
    plugins: '',
};

export default TinyMCEEditor;